export default __webpack_public_path__ + "static/media/ic_svc_samsung_o.80ef4dac.png";